import { slugify } from '@lyearn/core/utils/slugify';
import { ActionItemFragment } from '@/modules/tasks/features/actionItems/graphql/fragments/generated/ActionItem';
import { ProjectDashboardTabs } from '@/modules/tasks/views/ProjectsDashboard/types';

const learnerRoutes = {
  Tasks: () => `/tasks`,

  TasksOverview: (fileId: string) => `/tasks/${fileId}`,

  MyTaskOverview: () => `/tasks/my`,

  TeamTaskOverview: () => `/tasks/team`,

  AllTaskOverview: () => `/tasks/all`,

  TasksList: (fileId: string) => `/tasks/${fileId}`,

  Projects: () => `/projects`,

  ProjectsDashboard: (fileId: string) => `/projects/${fileId}`,

  ProjectTab: (fileId: string, tab?: ProjectDashboardTabs) => `/projects/${fileId}?tab=${tab}`,

  ProjectDiscussion: (fileId: string, channelId: string) =>
    `/projects/${fileId}?tab=${ProjectDashboardTabs.Discussions}&discussion=${channelId}`,

  ProjectsActivityFeed: (fileId: string) =>
    `/projects/${fileId}?tab=${ProjectDashboardTabs.ActivityFeed}`,

  TasksIssue: (
    actionItemId: string,
    actionItem?: Pick<ActionItemFragment, 'identifier' | 'title'>,
  ) => {
    const { title, identifier } = actionItem ?? {};
    let path = '';
    if (title) {
      const expectedSlug = slugify(title);
      path = `/tasks/issues/${identifier ?? actionItemId}/${expectedSlug}`;
    } else {
      path = `/tasks/issues/${identifier ?? actionItemId}/`;
    }
    return path;
  },

  TasksReports: () => `/tasks/reports`,
};

const routes = { ...learnerRoutes };

export default routes;
